var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{style:(`background-image: url('${_vm.bgBody}'); background-size: cover; /*background-attachment: fixed;*/`)},[_c('b-container',[_c('router-view'),_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }